import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/")) {
    cfg._retry = true;
    try {
      await api.post("/auth/refresh");
      return api(cfg);
    } catch { /* fall through */ }
  }
  return Promise.reject(error);
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo ha fallado. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e.message;

export const photoUrl = (p) => `${BACKEND}/api/photos/${p.id}/preview`;

// Mirrors backend crop: cover * zoom, offset = (scaled - box) * focus
export function bgStyle(photo, boxAspect) {
  const imgAspect = photo.width / photo.height;
  const z = photo.zoom * 100;
  return {
    backgroundImage: `url("${photoUrl(photo)}")`,
    backgroundSize: imgAspect > boxAspect ? `auto ${z}%` : `${z}% auto`,
    backgroundPosition: `${photo.fx * 100}% ${photo.fy * 100}%`,
    backgroundRepeat: "no-repeat",
  };
}
